import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from "primeng/dynamicdialog";
import { DataService_SubstituteMaintenance } from "../../../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-modify-substitution",
	templateUrl: "./modify-substitution.component.html",
	styleUrls: ["./modify-substitution.component.css"],
})
export class ModifySubstitutionComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private SubstituteMaintenanceService: DataService_SubstituteMaintenance
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.EditMode = this.dialogConfig.data.EditMode;

		//
		// Based on selected person
		//
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.user = this.dialogConfig.data.user;
		this.PersonName = this.dialogConfig.data.PersonName;
		this.Sub_PersonID = this.dialogConfig.data.Sub_PersonID;

		if (this.EditMode == true) {
			this.SelectedSubstitution = this.dialogConfig.data.SelectedSubstitution;

			this.UpdateSubstitution();
		} else {
			//Get data from DB
			this.loadInstructorList();
		}
	}

	UpdateSubstitution() {
		this.StartDate = new Date(this.SelectedSubstitution.StartDate);
		this.EndDate = new Date(this.SelectedSubstitution.EndDate);

		this.loadInstructorList();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	EditMode: any = false;

	//Input
	SubstitutionID: any = -1;
	SelectedSubstitution: any;

	SchoolID: any;
	user: any;

	//Form
	lstInstructor: any = [];
	SelectedInstructor: any;

	PersonName: any = "";
	Sub_PersonID: any = -1;

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	errorMessage: any = "";

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	loadInstructorList() {
		var result = this.SubstituteMaintenanceService.LoadInstructorList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstInstructor = response;

				for (var z = 0; z < this.lstInstructor.length; z++) {
					var next = this.lstInstructor[z];

					next.PersonName = next.FirstName + " " + next.LastName;
				}

				// this.Instructor_PersonID = this.lstInstructor[0].Instructor_PersonID;
				this.SelectedInstructor = this.lstInstructor[0];

				if (this.EditMode == true) {
					// this.Instructor_PersonID = this.SelectedSubstitution.PersonID;

					for (var z = 0; z < this.lstInstructor.length; z++) {
						var next = this.lstInstructor[z];

						if (next.Instructor_PersonID == this.SelectedSubstitution.PersonID) {
							this.SelectedInstructor = next;
							return;
						}
					}
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		//Error handling

		//Null
		if (this.SelectedInstructor == undefined || this.SelectedInstructor.Instructor_PersonID <= 0) {
			this.errorMessage = "Select an instructor to replace";
			return;
		}

		if (Number(this.Sub_PersonID) == Number(this.SelectedInstructor.Instructor_PersonID)) {
			this.errorMessage = "Substitute must be different from the person being replaced";
			return;
		}

		//Dates
		var Today: Date = new Date();
		Today.setHours(0, 0, 0, 0);
		this.StartDate.setHours(0, 0, 0, 0);
		this.EndDate.setHours(0, 0, 0, 0);

		if (this.StartDate < Today) {
			this.errorMessage = "Start Date cannot be before today";
			return;
		}
		if (this.EndDate < Today) {
			this.errorMessage = "End Date cannot be before today";
			return;
		}

		if (this.EndDate < this.StartDate) {
			this.errorMessage = "End date must be after the start date";
			return;
		}

		// @Substitute_PersonID INT,  //Instructor being replaced?
		// @Alias_PersonID  INT,  //Sub
		// @StartDate  DATE,
		// @EndDate  DATE,
		// @c_PersonID  INT

		var fsDate: String = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate: String = moment(this.EndDate).format("MM/DD/YYYY");

		var result = this.SubstituteMaintenanceService.SubstitutionInsert(
			this.Sub_PersonID,
			this.SelectedInstructor.Instructor_PersonID,
			fsDate,
			feDate,
			this.user.personID
		);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modifysub",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Substitute was assigned successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modifysub",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not assign the Substitution",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onEdit() {
		this.errorMessage = "";

		//Error handling

		//Null
		if (this.SelectedInstructor == undefined || this.SelectedInstructor.Instructor_PersonID <= 0) {
			this.errorMessage = "Select an instructor to replace";
			return;
		}

		if (Number(this.Sub_PersonID) == Number(this.SelectedInstructor.Instructor_PersonID)) {
			this.errorMessage = "Substitute must be different from the person being replaced";
			return;
		}

		//Dates
		var Today: Date = new Date();
		Today.setHours(0, 0, 0, 0);
		this.StartDate.setHours(0, 0, 0, 0);
		this.EndDate.setHours(0, 0, 0, 0);

		if (this.StartDate < Today) {
			this.errorMessage = "Start Date cannot be before today";
			return;
		}
		if (this.EndDate < Today) {
			this.errorMessage = "End Date cannot be before today";
			return;
		}

		if (this.EndDate < this.StartDate) {
			this.errorMessage = "End date must be after the start date";
			return;
		}

		// @Substitute_PersonID INT,  //Instructor being replaced?
		// @Alias_PersonID  INT,  //Sub
		// @StartDate  DATE,
		// @EndDate  DATE,
		// @c_PersonID  INT

		var fsDate: String = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate: String = moment(this.EndDate).format("MM/DD/YYYY");

		var result = this.SubstituteMaintenanceService.SubstitutionUpdate(
			this.SelectedSubstitution.SubstitutionID,
			this.SelectedInstructor.Instructor_PersonID,
			fsDate,
			feDate,
			this.user.personID
		);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modifysub",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Substitution was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modifysub",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Substitution",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onInstructorChange(val) {
		this.SelectedInstructor = val;
	}

	onShow() {
		// document.getElementById("ButtonDiv").style.width = "600px";
		// document.getElementById("ButtonDiv").style.height = "600px";
		// document.getElementById("MainGrid").style.marginBottom = "200px";
	}

	onHide() {
		// document.getElementById("ButtonDiv").style.width = "fit-content";
		// document.getElementById("ButtonDiv").style.height = "fit-content";
		// document.getElementById("MainGrid").style.marginTop = "0px";
	}

	////////////////////////////////////////////
}
